module.exports = __webpack_public_path__ + "assets/sa-flag.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sa-flag.png
// module id = 1671
// module chunks = 7